import { Injectable } from '@angular/core'
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router'
import { Observable } from 'rxjs'
import { ProfileService } from '../services/profile/profile.service'
import { GroupService } from '../services/group/group.service'
import { DataComponent } from '../app.routes'

@Injectable({
    providedIn: 'root',
})
export class GroupGuard {
    constructor(
        private perfilService: ProfileService,
        private router: Router,
        private groupService: GroupService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        const profile = this.perfilService.getUserProfile()
        const routeTarget = state.url.includes('?')
            ? state.url.split('?')[0]
            : state.url
        const routeData = route.data as DataComponent
        const excludedPaths: string[] = ['']
        const isExcluded = excludedPaths.some((path) =>
            routeTarget.startsWith(path)
        )

        // excluded routes
        if (isExcluded) {
            return true
        }

        // if superuser aditional validation layer, both methods can divide for bussisnes logic for protected modules
        if (
            profile &&
            (profile.is_staff || profile.is_superuser) &&
            routeData.protected
        ) {
            return true
        }

        return this.groupService.canAccess(routeTarget, profile)
    }
}
